import { track } from '@eventbrite/legacy-infra.datalayer-library';
import { getHeapPageArea } from './heapPageArea';

export const reTrackHeapEvent = ({
    affCode,
    eventId,
    heapEventName,
    shareMethod = null,
}: {
    affCode?: string;
    eventId: string;
    heapEventName: string;
    shareMethod?: string | null;
}) => {
    if (eventId && heapEventName) {
        const pageArea = getHeapPageArea(affCode) || 'uncategorized';
        const eventData = {
            eventId: eventId,
            pageArea: pageArea,
            shareMethod: shareMethod,
        };

        track({
            eventName: heapEventName,
            eventData,
        });
    }
};
